import { gql } from 'graphql-tag';

import { ImageFragments } from './ImageType';
import { ProductFragments } from './ProductType';

const productUnitId = gql`
  fragment ProductUnitId on ProductUnit {
    id
  }
`;

/**
 * Fragment for the productUnit sub-field inside SpeciesTopBaitNodeFields.
 * Used by components that need the top bait product unit details (e.g., TopBaitsEntry).
 */
const topBaitProductUnitFields = gql`
  fragment TopBaitProductUnitFields on ProductUnit {
    ...ProductUnitId
    image(height: 100) {
      ...ImageFields
    }
    attributeValues(first: 1) {
      edges {
        node {
          value {
            name
          }
        }
      }
    }
    product {
      ...ProductId
      ...ProductBrandName
      displayName
      category {
        title
      }
    }
  }
  ${productUnitId}
  ${ImageFragments.imageFields}
  ${ProductFragments.id}
  ${ProductFragments.brandName}
`;

const speciesTopBaitNodeFields = gql`
  fragment SpeciesTopBaitNodeFields on topEquipmentProductUnit {
    numberOfCatches
    position
    productUnit {
      ...TopBaitProductUnitFields
    }
  }
  ${topBaitProductUnitFields}
`;

const productUnitUsedByCurrentUser = gql`
  fragment ProductUnitUsedByCurrentUser on ProductUnit {
    usedByCurrentUser
  }
`;

export const ProductUnitFragments = {
  id: productUnitId,
  topBaitProductUnitFields,
  // While this may seem like a redundant fragment, it's important for enabling cache updates
  // when a user adds gear to their gearbox (see src/components/ProductUnitList/ProductUnitItem.tsx)
  usedByCurrentUser: productUnitUsedByCurrentUser,
  speciesTopBaitNodeFields,
  productUnitDetailNodeFields: gql`
    fragment ProductUnitDetailNodeFields on ProductUnit {
      ...ProductUnitId
      ...ProductUnitUsedByCurrentUser
      externalId
      model
      image(width: 768, height: 480) {
        ...ImageFields
      }
      attributeValues(first: 10) {
        edges {
          node {
            attribute {
              name
            }
            value {
              name
            }
          }
        }
      }
    }
    ${productUnitId}
    ${productUnitUsedByCurrentUser}
    ${ImageFragments.imageFields}
  `,
  productUnitEdgeFields: gql`
    fragment ProductUnitEdgeFields on ProductUnitEdge {
      node {
        ...ProductUnitId
        ...ProductUnitUsedByCurrentUser
        model
        image(width: 768, height: 480) {
          ...ImageFields
        }
        attributeValues(first: 10) {
          edges {
            node {
              attribute {
                name
              }
              value {
                name
              }
            }
          }
        }
      }
    }
    ${productUnitId}
    ${productUnitUsedByCurrentUser}
    ${ImageFragments.imageFields}
  `,
};
